/* unplugin-vue-components disabled */import { render } from "./smooth-resize.vue?vue&type=template&id=9cc7479a&scoped=true"
import script from "./smooth-resize.vue?vue&type=script&lang=js"
export * from "./smooth-resize.vue?vue&type=script&lang=js"

import "./smooth-resize.vue?vue&type=style&index=0&id=9cc7479a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc7479a"],['__file',"src/controls/smooth-resize.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9cc7479a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9cc7479a', __exports__)) {
    api.reload('9cc7479a', __exports__)
  }
  
  module.hot.accept("./smooth-resize.vue?vue&type=template&id=9cc7479a&scoped=true", () => {
    api.rerender('9cc7479a', render)
  })

}


export default __exports__